import { render, staticRenderFns } from "./clinicasActivas.vue?vue&type=template&id=06aeb612&scoped=true"
import script from "./clinicasActivas.vue?vue&type=script&lang=js"
export * from "./clinicasActivas.vue?vue&type=script&lang=js"
import style0 from "./clinicasActivas.vue?vue&type=style&index=0&id=06aeb612&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06aeb612",
  null
  
)

export default component.exports